import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { apiClientNoAuth } from "./_client";

export interface SiteBranding {
  logo_url: string | null;
}

export const useSiteBranding = (): UseQueryResult<SiteBranding> =>
  useQuery<SiteBranding>({
    queryKey: ["siteBranding"],
    queryFn: async () => {
      const response = await apiClientNoAuth.get<
        never,
        AxiosResponse<SiteBranding>
      >("api/branding/");
      return response.data;
    },
    // Match the endpoint's `Cache-Control: max-age=60`. Longer would mean a
    // freshly-uploaded admin logo stays invisible to already-open tabs for
    // minutes; shorter just churns React Query without bypassing the HTTP
    // cache.
    staleTime: 60 * 1000,
    retry: false,
  });
